import Swal from 'sweetalert2';

export const ConfirmBox = async (obj: object | any) => {
  if (!obj) {
    obj = {};
  }
  let {
    title,
    text,
    type,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText,
    allowOutsideClick,
    showCloseButton,
    background,
    html,
    cancelButtonClass,
    confirmButtonClass,
    raterRender,
    raterClose
  } = obj;
  return await Swal.fire({
    title: title || 'Are you sure?',
    text: text || 'You want to be able to revert this!',
    html: html || '',
    onRender: function() {
      if(raterRender) {
        var rater = document.getElementById("rater-box");
        var swal2content = document.getElementById("swal2-content");
        if(swal2content && rater) {
          rater.className = "";
          swal2content.appendChild(rater);
        }
      }
    },
    onClose: function() {
      if(raterClose) {
        var rater = document.getElementById("rater-box");
        if(rater && document.getElementsByTagName('body') && document.getElementsByTagName('body')[0]) {
          document.getElementsByTagName('body')[0].appendChild(rater);
          rater.className = "hide-element";
        }
      }
    },
    type: type || 'warning',
    showCancelButton: true,
    allowOutsideClick:
      allowOutsideClick !== 'undefined' ? allowOutsideClick : true,
    confirmButtonColor: confirmButtonColor || '#d33',
    cancelButtonColor: cancelButtonColor || '#3085d6',
    confirmButtonText: confirmButtonText || 'YES',
    cancelButtonText: cancelButtonText || 'NO',
    showCloseButton: showCloseButton || false,
    background: background || '#fff',
    cancelButtonClass: cancelButtonClass || '',
    confirmButtonClass: confirmButtonClass || ''
  });
};

export const AlertBox = async (obj: object | any) => {
  if (!obj) {
    obj = {};
  }
  let {
    title,
    text,
    type,
    confirmButtonColor,
    cancelButtonColor,
    confirmButtonText,
    cancelButtonText,
    allowOutsideClick,
    showCloseButton,
    background,
    html,
    cancelButtonClass,
    confirmButtonClass,
    raterRender,
    raterClose
  } = obj;
  return await Swal.fire({
    title: '<i class="fa fa-info-circle"></i>',
    text: text || 'You must attempt all questions to continue.',
    html: html || '',
    confirmButtonText: confirmButtonText || 'OK',    
    confirmButtonColor: confirmButtonColor || '#d33',
  });
};
